import React from 'react'

import Skeleton from '@/components/Skeleton'

/**
 * Semantic skeleton wrapper used by detail pages while loading.
 *
 * The existing {@link Skeleton} component only exposes `kpi`, `card`, and
 * `table-row` variants. `SkeletonPanel` layers a higher-level vocabulary on
 * top: `hero`, `metricGrid`, `list`, `report`. Each panel maps to a
 * recognisable section of the UI so detail pages can express loading
 * intent without per-page shape duplication.
 */
export type SkeletonPanelKind = 'hero' | 'metricGrid' | 'list' | 'report'

export default function SkeletonPanel({
  kind,
  count,
  marginTop = 16,
}: {
  kind: SkeletonPanelKind
  /** For list/metricGrid panels: number of placeholder rows / tiles. */
  count?: number
  marginTop?: number
}) {
  if (kind === 'hero') {
    return (
      <div className="card skeleton-card" style={{ marginTop }}>
        <div className="skeleton-line skeleton-short" />
        <div className="skeleton-line skeleton-wide" />
        <div className="skeleton-line skeleton-mid" />
      </div>
    )
  }
  if (kind === 'metricGrid') {
    return (
      <div style={{ marginTop }}>
        <Skeleton variant="kpi" count={count ?? 4} />
      </div>
    )
  }
  if (kind === 'list') {
    return (
      <div style={{ marginTop }}>
        <Skeleton variant="table-row" count={count ?? 5} />
      </div>
    )
  }
  return (
    <div style={{ marginTop }}>
      <Skeleton variant="card" count={count ?? 3} />
    </div>
  )
}
